import * as React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { } from "../api/transaction-type";
import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Grid,
} from "@mui/material";
import { useSelector } from "react-redux";
import useSnackbar from "../hooks/useSnackbar";
import useErrorHandler from "../hooks/useErrorHandler";
import { useParams } from "react-router-dom";

import { GridComp6, GridComp12 } from "./GridComponents";
import { CustomCheckBoxComp12 } from "./CheckboxComp";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle variant="h2" sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

export default function PaymentEventViewDialog({ open, id, handleClose, paymentEventData }) {
  const snackbar = useSnackbar();
  const errorHandler = useErrorHandler();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const [dialogTabIndex, setDialogTabIndex] = useState(0);

  return (
    <div className="dialogWidth">
      <BootstrapDialog
        aria-labelledby="customized-dialog-title"
        open={open}
        className="dialog-box"
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={() => {
            handleClose();
          }}
          className="closeBtn"
        >
          Payment Event
        </BootstrapDialogTitle>

        <DialogContent dividers>
          {/* body content */}
          <Box>
            {paymentEventData.map((d, i) => (
              <>
                <Grid container className="mb-2">
                  <Grid item xs={12} md={12} className="m-b-10">
                    <p className="titleHeading m-0">Primary Information</p>
                  </Grid>
                  <GridComp12 title={"PAYMENT OPERATION"} data={d.payment_operation} />
                  <GridComp12 title={"PAYMENT REQUEST ID"} data={d.payment_request_id} />
                  <GridComp12 title={"DATE"} data={d.date} />
                  <GridComp12 title={"HANDLING MODE"} data={d.handling_mode} />
                  <GridComp12 title={"TRANSACTION"} data={d.transaction} />
                  <GridComp12 title={"AMOUNT"} data={d.amount} />
                  <GridComp12 title={"PAYMENT PROCESSING PROFILE"} data={d.payment_processing_profile} />
                  <CustomCheckBoxComp12 title={"TEST MODE"} data={d.test_mode} />
                  <CustomCheckBoxComp12 title={"RECURRING PAYMENT"} data={d.recurring_payment} />
                  <CustomCheckBoxComp12 title={"PROCESSES WITH ADJUSTED EXPIRATION DATE"} data={d.processes_with_adjusted_expiration_date} />
                  <GridComp12 title={"PAYMENT INITIATOR"} data={d.payment_initiator} />
                  <GridComp12 title={"MIT PURPOSE"} data={d.mit_purpose} />

                  <Grid item xs={12} md={12} className="m-b-10">
                    <p className="titleHeading m-0">Payment Option</p>
                  </Grid>
                  <GridComp6 title={"TYPE"} data={d.type} />
                  <GridComp6 title={"STATE"} data={d.state} />
                  <GridComp6 title={"MASK"} data={d.mask} />

                  <Grid item xs={12} md={12} className="m-b-10">
                    <p className="titleHeading m-0">Response Information</p>
                  </Grid>
                  <GridComp6 title={"PAYMENT STATUS"} data={d.payment_status} />
                  <GridComp6 title={"P/N REF"} data={d.pn_ref} />
                  <GridComp6 title={"REASON"} data={d.reason} />
                  <GridComp6 title={"AUTH. CODE"} data={d.auth_code} />
                  <GridComp6 title={"DETAILS"} data={d.details} />
                </Grid>
              </>
            ))}
          </Box>
          {/* body content */}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              handleClose();
            }}
            className="backBtn"
          >
            Cancel
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
}
